'use client';

import { useState } from 'react';
import Description from './product-details/description';
import DescriptionAttributesModal from './product-details/description-attributes-modal';
import ProductAttributes from './product-details/product-attributes/product-attributes';
const PDPDescriptionAttributes = () => {
  const [modalType, setModalType] = useState<'description' | 'attributes'>();
  const isModalOpen = !!modalType;
  return <>
            <div className='pdp-container flex flex-col max-lg:my-4 max-lg:divide-y max-lg:divide-gray-300'>
                <Description openShowMoreModal={() => setModalType('description')} data-sentry-element="Description" data-sentry-source-file="pdp-description-attributes.tsx" />

                <ProductAttributes openShowMoreModal={() => setModalType('attributes')} data-sentry-element="ProductAttributes" data-sentry-source-file="pdp-description-attributes.tsx" />
            </div>

            <DescriptionAttributesModal defaultToAttributes={modalType === 'attributes'} isOpen={isModalOpen} onClose={() => setModalType(undefined)} data-sentry-element="DescriptionAttributesModal" data-sentry-source-file="pdp-description-attributes.tsx" />
        </>;
};
export default PDPDescriptionAttributes;